import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { Supervision, SupervisionStatusEnum } from 'solar-bo';
import { SupervStatusComponent } from './supervstatus.component';
import { MatDialog } from '@angular/material/dialog';
import { GlobalService } from '@solar/services/global.service';
import { ControlEnum } from 'solar-bo';


@Component({
    selector: "app-superv-status",
    template: `<i [ngClass]="class" (click)="openStatusChange()" matTooltip="{{tooltip}}"></i> {{statusName}}`
})
export class SupervStatusIconComponent implements OnInit, OnChanges {
    @Input() status: string;
    statusName: string = "";
    @Input() showStatusName: boolean = true;
    @Input() supervision: Supervision;
    @Input() options: { readonly: boolean } = { readonly: false };
    @Output() statusChange: EventEmitter<any> = new EventEmitter();
    statusCanBeChanged: boolean = false;
    tooltip = "";
    class: string = "status status-error fas fa-exclamation-circle";

    constructor(private dialog: MatDialog
        , private globService: GlobalService) { }

    ngOnInit() {
        //this.setClassByStatus(+this.status);
    }

    ngOnChanges() {
        this.setClassByStatus(this.status);
    }

    setClassByStatus(st?: string) {
        let newClass = "";
        let withpointer = "";
        if (this.options.readonly == false) {
            this.statusCanBeChanged = this.globService.checkAuthorizationById(ControlEnum.SUPERVISION_CHANGE_STATUS);
        } else {
            this.statusCanBeChanged = false;
        }


        if (this.supervision) {
            st = this.supervision.info.status;
            this.status = st;

            withpointer = "  ";
        }
        if (this.statusCanBeChanged) {
            this.tooltip = "Click here to change status.";
            withpointer = " withpointer ";
        }

        if (st === SupervisionStatusEnum.OPEN || st == SupervisionStatusEnum.CREATED) {
            newClass = withpointer + " status status-open fas fa-lock-open";
            this.tooltip = "Supervision is open for edition. ";
            this.statusName = "Open";
        } else if (st === SupervisionStatusEnum.LOADING) {
            newClass = "status status-warning fas fa-cogs";
            this.tooltip = "Supervision is loading data and can not be modified. ";
            this.statusName = "Loading";
        } else if (st === SupervisionStatusEnum.INPROCESS) {
            newClass = "status status-warning fas fa-cogs";
            this.tooltip = "Supervision is procesing data and can not be modified. ";
            this.statusName = "Processing";
        } else if (st === SupervisionStatusEnum.READYTOVALIDATE) {
            newClass = withpointer + " status status-open fas fa-eye";
            this.tooltip = "Supervision is ready to be validated.";
            this.statusName = "To eval";
        } else if (st === SupervisionStatusEnum.VALIDATED) {
            newClass = withpointer + " status status-validated fas fa-check-circle";
            this.tooltip = "Supervision is validated. ";
            this.statusName = "Validated";
        } else if (st === SupervisionStatusEnum.TOVALIDATE) {
            newClass = withpointer + " status status-warning fas fa-exclamation-triangle";
            this.tooltip = "Supervision need to be validated again. ";
            this.statusName = "Revalidation";
        } else if (st === SupervisionStatusEnum.DISCARDED) {
            newClass = withpointer + " status status-warning fas fa-lock";
            this.tooltip = "Supervision was discarded.";
            this.statusName = "Discarded";
        } else if (st === SupervisionStatusEnum.LOCKED) {
            newClass = withpointer + " status status-warning fas fa-lock";
            this.tooltip = "Supervision is locked.";
            this.statusName = "Locked";
        } else if (st == null) {
            newClass = "";
            this.tooltip = "";
            this.statusName = "";
        } else {
            newClass = withpointer + " status status-error fas fa-exclamation-circle";
            this.tooltip = "Unknown supervision status. Please contact system administrator.";
            this.statusName = "Unknown";
        }
        if (!this.showStatusName) {
            this.statusName = "";
        }
        this.class = newClass;
    }

    openStatusChange() {
    
        if (this.statusCanBeChanged==false) {
            return;
        }
        if (this.supervision) {
            let st = this.supervision.info.status;

            if (st === SupervisionStatusEnum.LOADING || st === SupervisionStatusEnum.INPROCESS) {
                this.tooltip = "Supervision can not modified until process ends.";
                return;
            }
            let dialogRef = SupervStatusComponent.openModal(this.dialog, this.supervision);
            dialogRef.componentInstance.statusChange.subscribe(newStatus =>
                this.statusChangeHandler(newStatus)
            );

        }
    }

    statusChangeHandler(status) {
        this.status = status;
        this.statusChange.next(status);
        this.supervision.info.status = status;
        this.setClassByStatus(this.status);
    }


}

